// External dependencies
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';

const Browser = styled.div`
  border-radius: 10px;
  border: 1px solid #999;
  margin: 10px auto;
  max-width: 620px;
  padding: 10px;
  width: 100%;
  @media (max-width: 991px) {
    border-radius: 6px;
    padding: 5px;
  }
`;

const BrowserCircle = styled.div`
  border-radius: 50%;
  border: 1px solid #999;
  float: left;
  height: 10px;
  margin: 0 5px 10px 0;
  width: 10px;
  @media (max-width: 991px) {
    height: 5px;
    width: 5px;
    margin: 0 3px 5px 0;
  }
`;

const BrowserVideo = styled.div`
  clear: both;
  display: block;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
  border-radius: 5px;
  position: relative;

  @media (max-width: 991px) {
    border-radius: 3px;
  }

  video {
    width: 100%;
    height: auto;
    display: block;
    cursor: pointer;
  }
`;

const PlayOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  color: white;
  background: rgba(0, 0, 0, 0.3);
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
`;

export default function VideoFrame({ src, autoPlay = true, loop = true }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(autoPlay);

  const togglePlayPause = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.muted = false; // 🔊 unmute when user interacts
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <Browser>
      <BrowserCircle />
      <BrowserCircle />
      <BrowserCircle />
      <BrowserVideo>
        <video
          ref={videoRef}
          autoPlay={autoPlay}
          loop={loop}
          playsInline
          muted // ✅ autoplay works
          onClick={togglePlayPause}
        >
          <source src={src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <PlayOverlay show={!isPlaying} onClick={togglePlayPause}>
          ▶
        </PlayOverlay>
      </BrowserVideo>
    </Browser>
  );
}

VideoFrame.propTypes = {
  src: PropTypes.string.isRequired,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
};
